<template>
  <div class="nav-points">
    <Icon />
    <span class="point-number sofia-medium" :key="navKey">{{ userPoints }}</span>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, onMounted, toRefs } from "vue";
import Icon from "@/components/atoms/points/point-icon.vue";
import { getUserPoints } from "@/apis/rewards.api";
import { isLoggedIn } from "@/compositions/auth";
import * as TotalPointsUsecase from "@/compositions/local-apis/total-points.usecase";
import { domainQuery } from "@/helpers/hostname.helper";

export default defineComponent({
  name: "component-nav-points",
  components: { Icon },
  props: {
    navKey: Number
  },
  setup() {
    // data
    const states = reactive({
      userPoints: 0
    });

    onMounted(async () => {
      await methods.getPoints();
    });

    const methods = {
      getPoints: async () => {
        if (!isLoggedIn()) {
          states.userPoints = await TotalPointsUsecase.getAllPoints();
          return;
        }
        try {
          const result = await getUserPoints(domainQuery());
          states.userPoints = result.totalPoint;
        } catch {
          console.error(`fet user point failed`);
          states.userPoints = 0;
        }
      }
    };

    return {
      ...toRefs(states),
      ...methods
    };
  }
});
</script>

<style lang="scss" scoped>
.nav-points {
  width: calc(102px - 24px);
  height: calc(32px - 16px);
  padding: 8px 16px 8px 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: $north-snow;
  border-radius: 24px;

  .material-icons {
    color: white;
    background-color: $orange;
    border-radius: 50%;
    padding: 8px;
  }

  .point-number {
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    line-height: 15px;
  }
}
</style>
